import { css } from "@emotion/react";

import { colors, dimensions, animations } from "@styles/index";

export const footerTop = css`
  background-color: ${colors.grey.darkFamily.dark};
  margin-top: 2.5rem;
  padding: 4rem 2rem 3rem;
`;

export const footerBottom = css`
  background-color: ${colors.backgroundWhite};
  padding: 1.5rem 2rem 1rem;
`;

export const contentWrapper = css`
  max-width: ${dimensions.maxContainer};
  margin: 0 auto;
`;

export const footerHeader = css`
  text-transform: uppercase;
  color: ${colors.white}!important;
`;

export const footerText = css`
  text-overflow: wrap;
  width: 25rem;
  margin-bottom: 2rem;
  @media (max-width: ${dimensions.phoneLarge}) {
    width: 17rem;
  }
`;

export const whiteText = css`
  color: ${colors.white}!important;
  font-weight: normal;
`;

export const sectionWrapper = css`
  display: flex;
  justify-content: space-between;
`;

export const fsLogo = css`
  width: 17rem;
  height: 2rem;
  margin-bottom: 0.75rem;
  margin-left: -2.25rem;
`;

export const actionButtonsWrapper = css`
  display: flex;
`;

export const link = css`
  color: ${colors.blue.base};
  &&&:hover {
    color: ${colors.blue.base};
  }
  align-self: center;
  margin: 0 1rem;

  @media (min-width: ${dimensions.tablet}) {
    margin: 0 2rem;
  }
`;

export const createAccountButton = css`
  margin-left: 1rem;
`;

export const seperator = css`
  margin: 1rem 0 1.875rem;
`;

export const column = css`
  margin-top: 3rem;

  @media (min-width: ${dimensions.tablet}) {
    margin-top: 1.5rem;
  }

  @media (min-width: ${dimensions.phone}) {
    margin-top: 1rem;
  }

  @media (min-width: ${dimensions.desktop}) {
    margin-top: 0;
  }
`;

export const linksList = css`
  li {
    line-height: 2;
    @media (hover: none) {
      line-height: 3rem;
    }
  }

  li a {
    ${animations.transition()};

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const columnBottom = css`
  margin-top: 2rem;
  margin-bottom: 0rem;

  @media (min-width: ${dimensions.phone}) {
    margin-top: 0rem;
  }

  @media (min-width: ${dimensions.desktop}) {
    margin-top: 0;
  }
`;

export const linksListBottom = css`
  li {
    margin-bottom: 1rem;
    @media (min-width: ${dimensions.phone}) {
      margin-top: 0.5rem;
    }
    @media (hover: none) {
      line-height: 3rem;
    }
  }
`;
